import Joi from "joi";
export const addCustomerSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      fullName: null,
      phoneNumber: null,
      shopName: null,
      debtorLimit: null,
      customer_code: null,
    },
    schema: Joi.object({
      fullName: Joi.string().required().min(1).max(40).messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.customer_modal.full_name.invalid,
        "string.min": joiMessage.customer_modal.full_name.min,
        "string.max": joiMessage.customer_modal.full_name.max,
      }),
      phoneNumber: Joi.string()
        .required()
        .pattern(/^(86\d{11}|(96478\d{8})|(96477\d{8})|(96475\d{8}))$/)
        .messages({
          "string.empty": joiMessage.common.required,
          "string.base": joiMessage.customer_modal.phone_number.invalid,
          "string.pattern.base": joiMessage.customer_modal.phone_number.case1,
        }),
      shopName: Joi.string()
        .allow(null, "")
        .min(1)
        .max(255)
        .optional()
        .messages({
          "string.base": joiMessage.customer_modal.shopName.invalid,
          "string.min": joiMessage.customer_modal.shopName.min,
          "string.max": joiMessage.customer_modal.shopName.max,
        }),
      debtorLimit: Joi.number().allow(null, "", NaN).optional().messages({
        "number.base": joiMessage.customer_modal.debtorLimit.invalid,
      }),
      customer_code: Joi.string().required().min(1).max(40).messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.customer_modal.customer_code.invalid,
        "string.min": joiMessage.customer_modal.customer_code.min,
        "string.max": joiMessage.customer_modal.customer_code.max,
      }),
    }),
    explicitCheck: {
      fullName: false,
      phoneNumber: false,
      shopName: false,
      debtorLimit: false,
      customer_code: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};

export const updateCustomerSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      fullName: null,
      phoneNumber: null,
      shopName: null,
      debtorLimit: null,
      customer_code: null,
    },
    schema: Joi.object({
      fullName: Joi.string()
        .allow(null, "")
        .optional()
        .min(1)
        .max(40)
        .messages({
          "string.base": joiMessage.customer_modal.full_name.invalid,
          "string.min": joiMessage.customer_modal.full_name.min,
          "string.max": joiMessage.customer_modal.full_name.max,
        }),
      phoneNumber: Joi.string()
        .allow(null, "")
        .optional()
        .pattern(/^(86\d{11}|(96478\d{8})|(96477\d{8})|(96475\d{8}))$/)
        .messages({
          "string.base": joiMessage.customer_modal.phone_number.invalid,
          "string.pattern.base": joiMessage.customer_modal.phone_number.case1,
        }),
      shopName: Joi.string()
        .allow(null, "")
        .min(1)
        .max(255)
        .optional()
        .messages({
          "string.base": joiMessage.customer_modal.shopName.invalid,
          "string.min": joiMessage.customer_modal.shopName.min,
          "string.max": joiMessage.customer_modal.shopName.max,
        }),
      debtorLimit: Joi.number().allow(null, "", NaN).optional().messages({
        "number.base": joiMessage.customer_modal.debtorLimit.invalid,
      }),
      customer_code: Joi.string()
        .allow(null, "")
        .optional()
        .min(1)
        .max(40)
        .messages({
          "string.base": joiMessage.customer_modal.customer_code.invalid,
          "string.min": joiMessage.customer_modal.customer_code.min,
          "string.max": joiMessage.customer_modal.customer_code.max,
        }),
    }),
    explicitCheck: {
      fullName: false,
      phoneNumber: false,
      shopName: false,
      debtorLimit: false,
      customer_code: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};
